"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.testHooks = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ZillowMapContext = _interopRequireDefault(require("./ZillowMapContext"));

var _Route = _interopRequireDefault(require("./Route"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/RoutesLayer.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var aqua200 = '#2BC1E1';
var aqua500 = '#0484A7';
var COLORS = [aqua200, aqua500];

var RoutesLayer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(RoutesLayer, _Component);

  function RoutesLayer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RoutesLayer.prototype;

  _proto.render = function render() {
    var _this$props,
        _this$props$routes,
        _this = this;

    return (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$routes = _this$props.routes) === null || _this$props$routes === void 0 ? void 0 : _this$props$routes.map(function (route, index) {
      return _react.default.createElement(_Route.default, {
        key: route,
        color: COLORS[index],
        route: route,
        gmap: _this.props.gmap,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 13
        },
        __self: this
      });
    });
  };

  return RoutesLayer;
}(_react.Component);

var mapContextToProps = function mapContextToProps(props) {
  return _react.default.createElement(_ZillowMapContext.default.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: this
  }, function (contextData) {
    if (contextData.gmap) {
      return _react.default.createElement(RoutesLayer, _extends({}, props, contextData, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23
        },
        __self: this
      }));
    }

    return null;
  });
};

RoutesLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  gmap: _propTypes.default.shape({}).isRequired,
  routes: _propTypes.default.arrayOf(_propTypes.default.string)
} : {};
var testHooks = {
  RoutesLayer: RoutesLayer
};
exports.testHooks = testHooks;
var _default = mapContextToProps;
exports.default = _default;